export default "__VITE_ASSET__DV6peGW3__"